module.exports = __webpack_public_path__ + "5e005130dd4fdf13c191b3ddf0fd9157.gif";